var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentificationCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 14C18 13.4477 18.4477 13 19 13H24C24.5523 13 25 13.4477 25 14C25 14.5523 24.5523 15 24 15H19C18.4477 15 18 14.5523 18 14Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 18C18 17.4477 18.4477 17 19 17H24C24.5523 17 25 17.4477 25 18C25 18.5523 24.5523 19 24 19H19C18.4477 19 18 18.5523 18 18Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5127 13C10.4081 13 9.5127 13.8954 9.5127 15C9.5127 16.1046 10.4081 17 11.5127 17C12.6173 17 13.5127 16.1046 13.5127 15C13.5127 13.8954 12.6173 13 11.5127 13ZM7.5127 15C7.5127 12.7909 9.30356 11 11.5127 11C13.7218 11 15.5127 12.7909 15.5127 15C15.5127 17.2091 13.7218 19 11.5127 19C9.30356 19 7.5127 17.2091 7.5127 15Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5123 19C10.8471 19 10.2007 19.221 9.67476 19.6284C9.14881 20.0357 8.77308 20.6061 8.60661 21.2502C8.46839 21.7849 7.92288 22.1063 7.38817 21.9681C6.85346 21.8299 6.53203 21.2844 6.67025 20.7497C6.94766 19.6765 7.57377 18.7258 8.4502 18.0471C9.32663 17.3684 10.4037 17 11.5122 17C12.6207 17 13.6978 17.3682 14.5743 18.0469C15.4508 18.7255 16.077 19.6761 16.3545 20.7494C16.4927 21.2841 16.1713 21.8296 15.6366 21.9678C15.1019 22.1061 14.5564 21.7847 14.4181 21.25C14.2516 20.606 13.8758 20.0355 13.3499 19.6282C12.8239 19.221 12.1775 19 11.5123 19Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7C3 5.89543 3.89543 5 5 5H27C28.1046 5 29 5.89543 29 7V25C29 26.1046 28.1046 27 27 27H5C3.89543 27 3 26.1046 3 25V7ZM27 7H5V25H27V7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentificationCard);
export default __webpack_public_path__ + "static/media/IdentificationCard.7fbca0e4ba019744ba3c46800aad9857.svg";
export { ForwardRef as ReactComponent };